 <mat-tab-group>
  <div *ngIf="listMinors && listMinors.length>0">
    <ng-container *ngFor="let minor of listMinors">
      <mat-tab class="firstTab">
          <ng-template mat-tab-label>
              <div class="container-fluid"  [ngClass]="minor && minor.status.active?'isActive':minor.status.pending?'isPending':'isAnactive'">
                <mat-icon class="align-middle">person</mat-icon>
                <span>{{minor.profile.email}}</span>
              </div>
          </ng-template>
        <app-minor (update)="updateMinor($event)"
         [email]="minor.profile.email" [isMinorPlus]="minor.data.isMinorPlus"
         [isMinor]="minor.data.isMinor" [tutorLastName]="minor.data.tutorLastName" 
         [tutorFirstName]="minor.data.tutorFirstName" [dataFvTeam]="minor.data.favouriteSoccerTeam" 
         [lang]="lang" [tutorUID]="tutorUID"[uid]="minor.UID" [isDeleted]="minor.data.status_info"
         (deleteMin)="deleteMin($event)" [isActive]="minor.isActive"  [profile]="minor.tilesProfile" 
         [consents]="minor.data.pending_consents || []" [optin]="minor.data.pending_custom_optins || []"></app-minor>
      </mat-tab>
    </ng-container>
  </div>

  </mat-tab-group>